import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { CONVERSATION_HOST_APP_INTERFACE_TOKEN } from '../../../../core/src/lib/tokens';

@Component({
  selector: 'inbox-conversation-title',
  templateUrl: './inbox-conversation-title.component.html',
  styleUrls: ['./inbox-conversation-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, NgStyle, NgClass, TranslateModule],
})
export class InboxConversationTitleComponent {
  private readonly hostAppInterface = inject(CONVERSATION_HOST_APP_INTERFACE_TOKEN);

  title$$ = new BehaviorSubject<string>('');
  title$ = this.title$$.asObservable();

  isInternalInfoDeleted = false;

  @Input() set conversationDetail(value: ConversationDetail | null) {
    if (!value) {
      return;
    }
    const title = this.hostAppInterface.getConversationTitleInfo(value).title;
    this.title$$.next(title);
    this.isInternalInfoDeleted = this.hostAppInterface.isRecipientInternalInfoDeleted(value);
  }

  @Input() conversationClosed = false;
  @Input() displayOnTopBar = false;
}
